import React from 'react'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import TrashIcon from '../../elements/icons/TrashIcon'
import { unSlugify } from '../../../utils';

const DepartmentCard = ({department, openDepartment, deleteDepartment}) => {
  return (
    <div className='p-3 relative min-h-[300px]'>
        <p className='font-medium'>{department.name}</p>
        <p className='text-sm text-gray-500 '>{department.description}</p>

        {department.hod && <p className='text-lg mt-3 text-gray-500 font-medium'>
            <span className='text-xs text-gray-400 mt-3'>Current HOD: </span><span className='font-space-grotesk text-sm text-gray-800'>{department.hod?.fullName}</span>
        </p>}

        <span className={`px-2 capitalize w-max inline-block rounded text-xs font-outfit py-1 mt-2 ${department.type === 'non-academic' ? 'text-blue-500 bg-blue-600 bg-opacity-10' : 'bg-vcm-light-purple text-vcm-purple bg-opacity-30'}`}>
          {unSlugify(department.type)}</span>

        <div className="w-full flex items-center justify-between mt-3 p-3 border-t absolute left-0 bottom-0">
            <button onClick={()=>{openDepartment()}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>View/Edit Department <ArrowIcon className={`w-5 h-5`} /></button> 

            <button onClick={()=>{deleteDepartment()}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                <TrashIcon className={`w-5 h-5`} />
            </button>
        </div>
    </div>
  )
}

export default DepartmentCard